module.exports = __webpack_public_path__ + "880b7c666e44cc84ef0e8cc97ac431e8.fbx";